// Alerts.jsx
import React, { useState } from "react";
import { useActiveAlerts } from "../hooks/useData";

const SEVERITY_COLORS = {
  critical: "#FF4444", high: "#F97316", medium: "#FBBF24", low: "#10B981"
};
const SEVERITY_ORDER = ["critical", "high", "medium", "low"];

export function Alerts() {
  const [filter, setFilter] = useState("all");
  const { data, isLoading } = useActiveAlerts();

  const alerts = data?.alerts || [];
  const filtered = filter === "all" ? alerts : alerts.filter(a => a.severity === filter);

  const counts = SEVERITY_ORDER.reduce((acc, s) => {
    acc[s] = alerts.filter(a => a.severity === s).length;
    return acc;
  }, {});

  return (
    <div className="fade-in">
      <h1 style={{ fontFamily: "var(--mono)", fontSize: 20, marginBottom: 6 }}>ALERTS</h1>
      <p style={{ color: "var(--subtext)", fontSize: 12, marginBottom: 20 }}>
        Environmental threshold breaches · Auto-detected
      </p>

      {/* Summary row */}
      <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
        {SEVERITY_ORDER.map(s => (
          <div key={s} className="card" style={{
            flex: 1, cursor: "pointer",
            borderColor: filter === s ? SEVERITY_COLORS[s] : "var(--border)",
            background: filter === s ? `rgba(${s === "critical" ? "255,68,68" : s === "high" ? "249,115,22" : s === "medium" ? "251,191,36" : "16,185,129"},.08)` : "var(--surface)",
          }} onClick={() => setFilter(filter === s ? "all" : s)}>
            <div className="card-title">{s.toUpperCase()}</div>
            <div style={{ fontSize: 28, fontFamily: "var(--mono)", fontWeight: 700, color: SEVERITY_COLORS[s] }}>
              {counts[s]}
            </div>
          </div>
        ))}
      </div>

      {/* Alert list */}
      <div className="card">
        <div className="card-title">
          {filter === "all" ? `All Alerts · ${alerts.length}` : `${filter.toUpperCase()} · ${filtered.length}`}
        </div>
        {isLoading ? (
          Array(6).fill(0).map((_, i) => <div key={i} className="skeleton" style={{ height: 56, marginBottom: 8 }} />)
        ) : filtered.length === 0 ? (
          <div style={{ color: "var(--success)", padding: "20px 0", fontSize: 13 }}>✓ No alerts at this severity level</div>
        ) : filtered.map((a, i) => (
          <div key={i} style={{
            display: "flex", gap: 16, padding: "12px 0",
            borderBottom: "1px solid var(--border)", alignItems: "flex-start",
          }}>
            <div style={{
              width: 4, borderRadius: 2, alignSelf: "stretch",
              background: SEVERITY_COLORS[a.severity] || "var(--border)",
              flexShrink: 0,
            }} />
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                <span style={{ fontFamily: "var(--mono)", fontSize: 10, color: SEVERITY_COLORS[a.severity], fontWeight: 700 }}>
                  {a.severity?.toUpperCase()}
                </span>
                <span style={{ fontSize: 10, color: "var(--subtext)" }}>{a.type}</span>
                {a.country && <span style={{ fontSize: 10, color: "var(--subtext)" }}>· {a.country}</span>}
              </div>
              <div style={{ fontSize: 13 }}>{a.message}</div>
              {a.coordinates && (
                <div style={{ fontSize: 10, color: "var(--subtext)", marginTop: 3, fontFamily: "var(--mono)" }}>
                  {a.coordinates.latitude?.toFixed(2) || a.coordinates.lat?.toFixed(2)}, {a.coordinates.longitude?.toFixed(2) || a.coordinates.lon?.toFixed(2)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Alerts;
